import useHotline from './hooks/useHotline';
function Hotline({ data, getLat, getLng, getVal, options, eventHandlers, }) {
    useHotline({ data, getLat, getLng, getVal, options, eventHandlers });
    return null;
}
export default Hotline;
